import ComicCard from '@/components/base/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 12);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-900 font-heading">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日同步更新最新章节</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {latestComics.map((comic, index) => {
            const cat = categories.find(c => c.slug === comic.category);
            return (
              <ComicCard
                key={comic.id}
                slug={comic.slug}
                title={comic.title}
                author={comic.author}
                coverImage={comic.coverImage}
                description={comic.description}
                category={comic.category}
                categoryName={cat?.name || comic.category}
                status={comic.status}
                rating={comic.rating}
                views={comic.views}
                updatedAt={comic.updatedAt}
                chapterCount={comic.chapterCount}
                index={index}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}